<!-- ==========================================
     PROACTIVE GREETING BUBBLE
=========================================== -->
@if (showGreeting && !isOpen) {
<div class="ai-greeting-bubble" (click)="toggleChat()">
  <button type="button" class="ai-greeting-close" aria-label="Dismiss" (click)="dismissGreeting($event)">
    <i class="bi bi-x"></i>
  </button>
  <p><strong>Hi 👋</strong> Need help choosing a plan or checking your device?</p>
</div>
}

<!-- ==========================================
     FLOATING TRIGGER
=========================================== -->
<button type="button" class="ai-chat-fab" [class.is-open]="isOpen" (click)="toggleChat()"
  [attr.aria-expanded]="isOpen" aria-label="Open Jadhu AI assistant">
  <span class="ai-fab-ring" aria-hidden="true"></span>
  @if (!isOpen) {
  <i class="bi bi-stars"></i>
  } @else {
  <i class="bi bi-x-lg"></i>
  }
</button>

<!-- ==========================================
     CHAT PANEL
=========================================== -->
@if (isOpen) {
<section class="ai-chat-panel" role="dialog" aria-modal="false" aria-label="Jadhu AI assistant chat">

  <header class="ai-chat-header">
    <div class="ai-chat-avatar">
      <i class="bi bi-stars"></i>
    </div>
    <div class="ai-chat-heading">
      <h3>Jadhu Assistant</h3>
      <span><span class="status-dot"></span> AI-powered · Online</span>
    </div>
    <button type="button" class="ai-chat-close" aria-label="Close chat" (click)="closeChat()">
      <i class="bi bi-x-lg"></i>
    </button>
  </header>

  <div class="ai-chat-body" #chatBody>

    @for (message of messages; track $index) {
    <div class="ai-msg-row" [class.is-user]="message.sender === 'user'">
      @if (message.sender === 'bot') {
      <div class="ai-msg-avatar"><i class="bi bi-stars"></i></div>
      }
      <div class="ai-msg-bubble">
        <p>{{ message.text }}</p>
        <span class="ai-msg-time">{{ message.time }}</span>
      </div>
    </div>
    }

    @if (isTyping) {
    <div class="ai-msg-row">
      <div class="ai-msg-avatar"><i class="bi bi-stars"></i></div>
      <div class="ai-msg-bubble ai-typing">
        <span></span><span></span><span></span>
      </div>
    </div>
    }

  </div>

  <div class="ai-quick-replies">
    @for (reply of quickReplies; track reply.label) {
    <button type="button" class="ai-quick-chip" (click)="sendQuickReply(reply)">
      <i class="bi" [class]="reply.icon"></i> {{ reply.label }}
    </button>
    }
  </div>

  <form class="ai-chat-input" (submit)="$event.preventDefault(); sendMessage()">
    <input type="text" name="message" placeholder="Type your question…" autocomplete="off"
      [(ngModel)]="inputValue" />
    <button type="submit" aria-label="Send message" [disabled]="!inputValue.trim()">
      <i class="bi bi-send"></i>
    </button>
  </form>

  <p class="ai-chat-footer">Powered by {{ brandName }} AI · Answers may be inaccurate</p>

</section>
}
